import * as React from 'react';
import { css } from '@emotion/core';
import { COLORS } from '../../globalStyle/colors';
import { useSelector } from 'react-redux';
import { AppState } from '../../core/redux/appState';
import { TextDirection } from '../../localization/textDirection';
import { strictEquals } from '../../language/module';


const styles = {
  root: css`
    background-color: ${COLORS.WHITE};
    border-radius: 10px;
    padding: 25px;
  `,
};


interface Props extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  localizeDir?: boolean;
}


/**
 * Card: a component that renders a div with TruScore card styling. Localizes direction by default.
 *
 * PureComponent: true
 * Redux Connected: true
 */
const Card: React.FC<Props> = props => {
  const layoutDirection = useSelector<AppState, TextDirection>(
    state => state.locale.textDirection,
    strictEquals,
  );

  // React complains if you forward unknown props to HTML elements >.>
  const { localizeDir, ...rest } = props;

  const dirProps = React.useMemo(
    () => localizeDir ? { dir: layoutDirection } : {},
    [localizeDir, layoutDirection],
  );

  return (
    <div css={styles.root} {...rest} {...dirProps} />
  );
};

Card.defaultProps = {
  localizeDir: true,
};

export default Card;
